export interface IDeduplicationSet {
  has: (deduplicationId: string) => boolean;
  add: (deduplicationId: string) => void;
  reset: () => void;
}

export const createDeduplicationSet = (config?: {
  deduplicationInterval?: number;
}) => {
  const deduplicationIds = new Set<string>();

  const has = (deduplicationId: string) => {
    return deduplicationIds.has(deduplicationId);
  };

  const add = (deduplicationId: string) => {
    deduplicationIds.add(deduplicationId);
    if (config?.deduplicationInterval) {
      setTimeout(() => {
        deduplicationIds.delete(deduplicationId);
      }, config.deduplicationInterval);
    }
  };

  const reset = () => {
    deduplicationIds.clear();
  };

  return {
    has,
    add,
    reset,
  };
};
